import { render, staticRenderFns } from "./ArchivePurchasePayments.vue?vue&type=template&id=1ee16ad7&"
import script from "./ArchivePurchasePayments.vue?vue&type=script&lang=js&"
export * from "./ArchivePurchasePayments.vue?vue&type=script&lang=js&"
import style0 from "./ArchivePurchasePayments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArchivePurchasePayments.vue"
export default component.exports